import React, {ChangeEvent, SetStateAction, Dispatch} from 'react';
import {Dispatch as ReduxDispatch, AnyAction} from 'redux';
import {AutocompleteChangeReason} from '@material-ui/lab/useAutocomplete/useAutocomplete';
import {ValidationErrors} from 'final-form';

export enum QcJobTestStatuses {
    ReadyForQc = 'READY_FOR_QC',
    InQc = 'IN_QC',
    QcFailed = 'QC_FAILED',
    QcPassed = 'QC_PASSED',
}

export interface BulkBody {
    id: number;
    userId?: number;
    status?: QcJobTestStatuses;
    priority?: number;
}

export enum NoteType {
    media = 'media',
    metadata = 'metadata',
    rights = 'rights',
    artwork = 'artwork',
    validation= 'validation',
}

export enum QcJobStatuses {
    Passed = 'PASSED',
    Pending = 'PENDING',
    Failed = 'FAILED',
    Warning = 'WARNING',
    Idle = '',
}

export interface UpdateQcJobStatusParams {
    type: NoteType;
    status: QcJobStatuses;
}

export interface DefaultFiltersPros {
    variant?: 'standard' | 'outlined' | 'filled' | undefined;
    className?: string;
    hideLabel?: boolean;
    placeholder?: string;
    value: string;
    onChange: () => void;
}

export interface EditQcReportNoteBody {
    timespanCategoryId: number;
    value: string;
}
export interface DeleteQcReportNoteParams {
    qcJobId: string;
    timespanId: number;
}

export type CheckboxChangeEvent = (event: ChangeEvent<{}>, checked: boolean) => void;

export type OnStringSetState = React.Dispatch<SetStateAction<string>>;
export type OnNumberSetState = React.Dispatch<SetStateAction<number>>;
export type OnBooleanSetState = Dispatch<SetStateAction<boolean>>;
export type OnInputChangeEvent = ChangeEvent<HTMLInputElement>;
export type OnMouseDivEvent = React.MouseEvent<HTMLDivElement>;
export type OnMouseButtonEvent = React.MouseEvent<HTMLButtonElement, MouseEvent>;
export type OnAnchorElSet = (value: SetStateAction<Element | null>) => void;
export type OnBlurEvent = React.FocusEvent<HTMLInputElement>;
export type OnClickEvent = (event: React.MouseEvent) => void;
export type OnKeyboardEvent = React.KeyboardEvent<HTMLInputElement> & { target: HTMLInputElement };
export type OnChangeInputType = (e: OnInputChangeEvent) => void;
export type OnChangeTextFieldEvent = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
export type OnChangeSwitchEvent = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
export type AutocompleteOnChange = (event: ChangeEvent<{}>, value: string | null, reason: AutocompleteChangeReason) => void;
export type OnSelectChangeEvent = ChangeEvent<{ name?: string; value: unknown }>;
export type BlankChangeEvent = ChangeEvent<{}>;
export type Validations = ValidationErrors | Promise<ValidationErrors> | undefined;
export type UseParamsId = {id?: string};

export type DispatchAny = ReduxDispatch<AnyAction>;
